<!-- Card -->
<section class="card mb-3">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.uploadedDocuments' | translate }}
    </h3>
  </div>

  <document-table
    [tableData]="documents$ | async"
    [bulkActions]="[BulkAction.DELETE]"
    (onBulkAction)="onBulkAction($event)"
  ></document-table>
</section>

<!-- Card -->
<section class="card mb-3">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.uploadDocument' | translate }}
    </h3>
  </div>
  <!-- End Header -->
  <!-- Body -->
  <div class="col-sm p-4">
    <upload-file
      (onSubmitFile)="onSubmitImage($event)"
      [overwrite]="false"
    ></upload-file>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
